import DuplicateCriteria from "../../features/CRUD/crudCriteriaList/Components/duplicateCriteria/DuplicateCriteria"

const DuplicateCriteriaForm  = () => {
  return (
    <div>
      <DuplicateCriteria />
    </div>
  )
}

export default DuplicateCriteriaForm
